export default "__VITE_PUBLIC_ASSET__ae10fce4__"